import React, { useEffect, useState, useRef } from "react";
import { proxyAvatar } from "../../helper/ImageProxy";

import {
  Link,
  NavLink,
  Outlet,
  redirect,
  useBeforeUnload,
  useLocation,
  useNavigate,
  useNavigation,
  useResolvedPath,
} from "react-router-dom";
import { useDisclosure, useQueue } from "@mantine/hooks";
import {
  AppShell,
  Group,
  Burger,
  Skeleton,
  ScrollArea,
  Text,
  Anchor,
  Input,
  Flex,
  Avatar,
  Menu,
  rem,
  UnstyledButton,
  Paper,
  Box,
  Button,
  Modal,
  ThemeIcon,
} from "@mantine/core";
import _breadcrumb from "./_breadcrumb";
import { AuthProvider } from "../../helper/IAuthProvider";
import { SkeletonBase } from "./_skeleton";
import {
  IconChevronDown,
  IconChevronRight,
  IconChevronUp,
  IconDownload,
  IconLogout,
  IconMessageCircle,
  IconPencil,
  IconPhoto,
  IconSearch,
  IconSettings,
  IconUser,
  IconUserCircle,
  IconUserFilled,
  IconAlertCircle,
  IconInfoCircle,
  IconAlertTriangle,
} from "@tabler/icons-react";
import classes from "../../_style/NavbarSegmented.module.css";
import { _sideNavData } from "../../../_setup/navdata/_sideNavData";
import { LinksGroup } from "./NavbarLinksGroup";
import { isNullOrEmpty } from "../../extension/StringExtension";
import { searchSideNavData } from "../../helper/FunctionHelper";
import { LinksGroupProps } from "../../model/_base/LinksGroupProps";
import TokenService from "../../../api/login/token.service";
import { NotificationExtension } from "../../extension/NotificationExtension";

import { UserLogin } from "../../../model/UserData";
import { ImageCore } from "../../../views/Flow-step/ImageCore";
import { UserMode } from "../../../model/UserMode";
import { UserModel } from "../../../model/UserModel";
import { noCheckAuth, repositorySign, url403 } from "../../_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import {
  checkHacomSignPlugin,
  HacomSignPluginStatus,
} from "../../helper/HacomSignPlugin";
import { modals } from "@mantine/modals";
import { RecovyPassNodeCode } from "./RecovyPassNodeCode";
import { IconMailOpened } from "@tabler/icons-react";
import imageLogo from "../../../assets/images/logoE-sign.png";
import { NotificationBell } from "../NotificationBell";
import { NewYearCelebration } from "./NewYearCelebration";

//context

// Endpoint của Aspose licensing agent chạy nội bộ trên máy trạm để xác thực bản quyền.
const LICENSE_CHECK_URL = "http://localhost:5555";
// Đánh dấu đã xác thực bản quyền thành công trong phiên tab hiện tại (sessionStorage
// sống theo tab) để tránh gọi lại licensing agent ở mỗi lần điều hướng.
const LICENSE_TAB_FLAG = "aspose-license-verified";
// Chu kỳ tái xác thực bản quyền (revalidate) — mỗi 3 giờ.
const LICENSE_CHECK_INTERVAL_MS = 6 * 60 * 60 * 1000;

type AsposeLicenseError = { code: string; title: string; message: string };

// Ánh xạ mã trạng thái trả về từ licensing agent sang thông báo lỗi bản quyền
// hiển thị cho người dùng.
const buildAsposeLicenseError = (status: number): AsposeLicenseError => {
  switch (status) {
    case 404: // License đã hết hạn
      return {
        code: "Aspose.License.LicenseException",
        title: "License verification failed",
        message:
          "The subscription included in this license has expired and is not valid for the currently installed version of the product. Renew the subscription or apply an updated license file.",
      };
    case 500: // License không hợp lệ / lỗi khởi tạo
      return {
        code: "Aspose.License.LicenseException",
        title: "License verification failed",
        message:
          "Cannot initialize the license. The license file is invalid or its signature could not be verified.",
      };
    case 401: // Không tìm thấy license
      return {
        code: "Aspose.License.LicenseException",
        title: "License verification failed",
        message:
          "A valid license was not found. The product is running in evaluation mode and cannot be used until a license is set.",
      };
    default:
      return {
        code: "Aspose.License.LicenseException",
        title: "License verification failed",
        message:
          "The license could not be verified. The licensing service did not respond.",
      };
  }
};

export const Layout1 = () => {
  // #region state

  const location = useLocation();
  const navigate = useNavigate();
  const [loadingSkeleton, setLoadingSkeleton] = useState(true);
  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(
    window.innerWidth >= 768, // true cho desktop (>=768px), false cho mobile (<768px)
  );
  const [sideNavs, setSideNavs] = useState<LinksGroupProps[]>([]);
  const [menuOpened, setMenuOpened] = useState(false);
  const [userLogin, setUserLogin] = useState<UserModel | null>(
    localStorage.getItem("userLogin")
      ? JSON.parse(localStorage.getItem("userLogin") as string)
      : null,
  );
  const [isLatestVersion, setIsLatestVersion] = useState<boolean | null>(null);
  const [pluginStatus, setPluginStatus] = useState<HacomSignPluginStatus>();
  const [isLoadingVersion, setIsLoadingVersion] = useState(false);
  const [licenseError, setLicenseError] = useState<AsposeLicenseError | null>(
    null,
  );
  const previousPath = useRef(location.pathname);

  useEffect(() => {
    console.log("loadingSkeleton", loadingSkeleton);
  }, [loadingSkeleton]);
  //#endregion

  //#region  auth
  //#endregion
  useEffect(() => {
    setLoadingSkeleton(false);
    window.scrollTo(0, 0);
    const token = AuthProvider.isAuthenticated();
    if (!token) {
      navigate("/auth/login");
    }

    // Chỉ đóng sidebar trên mobile khi thực sự chuyển route
    if (
      previousPath.current !== location.pathname &&
      window.innerWidth < 768 &&
      desktopOpened
    ) {
      toggleDesktop();
    }

    // Cập nhật path hiện tại
    previousPath.current = location.pathname;
    if (previousPath.current === "/") {
      navigate("/dashboard");
    }
    return () => {
      setLoadingSkeleton(true);
    };
  }, [location, navigate, desktopOpened, toggleDesktop]);

  //

  // const navigation = useNavigation();
  // const isNavigating = Boolean(navigation.location);
  // useEffect(() => {
  //   console.log("navigation1", navigation);
  // }, [navigation]);

  // matine

  const renderLogo = () => (
    <div className="e-folder">
      <div className="e-folder-name">
        <img
          alt=""
          style={{
            width: window.innerWidth < 768 ? 50 : 60,
            height: window.innerWidth < 768 ? 50 : 60,
          }}
          src={imageLogo}
        />
      </div>
    </div>
  );
  // search menu
  function searchDataSide(q: string) {
    if (isNullOrEmpty(q)) return setSideNavs(_sideNavData);
    return setSideNavs(searchSideNavData(_sideNavData, q));
  }
  const searchModel = (
    <Input
      placeholder="Tìm kiếm"
      leftSection={<IconSearch size={16} />}
      onChange={(e: any) => searchDataSide(e.target.value)}
    />
  );
  const links = sideNavs.map((item) => (
    <LinksGroup {...item} key={item.label} />
  ));

  const handleLogout = () => {
    TokenService.removeUser();
    localStorage.setItem("userName", "");
    NotificationExtension.Success("Bạn đã đăng xuất thành công");
    navigate("/auth/login");
  };
  const handleNavigateToProfile = () => {
    navigate("/profile");
  };

  useEffect(() => {
    // if (userName === "hopxc1997@gmail.com" || userName === "vinhnv")
    //   setSideNavs(_sideNavData);
    // else {
    //   getMenu();
    // }
    getMenu();
    checkVersion();
    // Tạm tắt kiểm tra bản quyền Aspose (bật lại bằng cách bỏ comment bên dưới).
    // checkLicense();
    // // Tái xác thực bản quyền định kỳ để phát hiện license hết hạn/thu hồi giữa phiên.
    // const licenseTimer = setInterval(checkLicense, LICENSE_CHECK_INTERVAL_MS);
    // return () => clearInterval(licenseTimer);
  }, []);

  const checkVersion = async () => {
    setIsLoadingVersion(true);
    try {
      const check = await checkHacomSignPlugin();
      setPluginStatus(check.status);
      setIsLatestVersion(check.status === "ready");
    } finally {
      setIsLoadingVersion(false);
    }
  };

  // Xác thực bản quyền Aspose với licensing agent nội bộ. Kết quả được cache theo
  // phiên tab: đã xác thực thành công thì không gọi lại khi điều hướng trong cùng tab.
  const checkLicense = async () => {
    if (sessionStorage.getItem(LICENSE_TAB_FLAG) === "ok") return;
    try {
      const response = await fetch(LICENSE_CHECK_URL);
      if (response.ok) {
        sessionStorage.setItem(LICENSE_TAB_FLAG, "ok");
        setLicenseError(null);
        return;
      }
      // 404: license hết hạn, 500: license lỗi, 401: không tìm thấy license
      setLicenseError(buildAsposeLicenseError(response.status));
    } catch (error) {
      // Không kết nối được tới licensing agent (vd: ERR_CONNECTION_REFUSED) → không
      // thể xác thực bản quyền, chặn tính năng để bảo đảm tuân thủ (fail-closed).
      console.error("Không kiểm tra được bản quyền:", error);
      setLicenseError(buildAsposeLicenseError(0));
    }
  };

  const openInstallGuideModal = () => {
    modals.open({
      title: "Hướng dẫn cài đặt trình ký số",
      size: "xl",
      children: (
        <ScrollArea.Autosize mah={600}>
          <Box p="md">
            <Text size="sm" mb="md" c="gray.7">
              Để cài đặt bộ cài mới nhất, vui lòng làm theo các bước sau:
            </Text>

            <Box mb="lg">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 1: Tải file gỡ cài đặt
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                Tải file <strong>UnInstallHacomEsign.cmd</strong> để gỡ toàn bộ
                các phiên bản cũ đang có trên máy tính của bạn.
              </Text>
              <Button
                component="a"
                href="/UnInstallHacomEsign.cmd"
                download="UnInstallHacomEsign.cmd"
                leftSection={<IconDownload size={16} />}
                variant="light"
                color="blue"
                mb="md"
                fullWidth
              >
                Tải file UnInstallHacomEsign.cmd
              </Button>
            </Box>

            <Box mb="lg">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 2: Chạy file gỡ cài đặt
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                1. Nhấp chuột phải vào file{" "}
                <strong>UnInstallHacomEsign.cmd</strong> và chọn{" "}
                <strong>
                  "Chạy với tư cách quản trị viên hoặc run as administrator"
                </strong>
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                2. File sẽ tự động quét và tìm các phiên bản Hacom Sign đang có
                trên máy:
              </Text>
              <Box
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginBottom: "12px",
                }}
              >
                <img
                  src="/anhquetverrsion.png"
                  alt="Kết quả quét version"
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                  }}
                />
              </Box>
              <Text size="sm" mb="xs" c="gray.7">
                3. Nhập <strong>'y'</strong> để xác nhận gỡ cài đặt. Quá trình
                sẽ tự động:
              </Text>
              <Box
                component="ul"
                style={{ paddingLeft: "20px", marginTop: "8px" }}
              >
                <li style={{ marginBottom: "4px" }}>
                  <Text size="sm" c="gray.7">
                    Đóng các ứng dụng Hacom Sign đang chạy
                  </Text>
                </li>
                <li style={{ marginBottom: "4px" }}>
                  <Text size="sm" c="gray.7">
                    Gỡ cài đặt từ Registry
                  </Text>
                </li>
                <li style={{ marginBottom: "4px" }}>
                  <Text size="sm" c="gray.7">
                    Xóa các file và thư mục còn sót lại
                  </Text>
                </li>
              </Box>
              <Box
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: "8px",
                  overflow: "hidden",
                  marginTop: "12px",
                }}
              >
                <img
                  src="/anhketquasaukhiquetxong.png"
                  alt="Kết quả sau khi gỡ xong"
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                  }}
                />
              </Box>
            </Box>

            <Box mb="lg">
              <Text size="sm" fw={600} mb="xs" c="blue.7">
                Bước 3: Tải và cài đặt bộ cài mới nhất
              </Text>
              <Text size="sm" mb="xs" c="gray.7">
                Sau khi gỡ xong, tải bộ cài trình ký số mới nhất và cài đặt như
                bình thường.
              </Text>
              <Button
                component="a"
                href="https://cdn-files.hacom.vn/hacom/extension/App-win/HacomSignSetup.exe"
                leftSection={<IconDownload size={16} />}
                variant="filled"
                color="blue"
                mt="xs"
                fullWidth
              >
                Tải bộ cài trình ký số mới nhất
              </Button>
            </Box>

            <Box
              style={{
                padding: "12px",
                backgroundColor: "#fff3cd",
                borderRadius: "6px",
                border: "1px solid #ffc107",
                marginTop: "16px",
              }}
            >
              <Text size="xs" c="orange.8" fw={500}>
                ⚠ Lưu ý: Quá trình gỡ cài đặt cần quyền Administrator. Vui lòng
                đảm bảo bạn đã chạy file với quyền quản trị viên.
              </Text>
            </Box>

            <Box
              style={{
                padding: "16px",
                backgroundColor: "#f8d7da",
                borderRadius: "8px",
                border: "2px solid #dc3545",
                marginTop: "20px",
              }}
            >
              <Text size="sm" fw={700} mb="md" c="red.8">
                ⚠️ CHÚ Ý QUAN TRỌNG: Cấp quyền truy cập mạng nội bộ
              </Text>
              <Text size="sm" mb="xs" c="gray.8" fw={500}>
                Một số máy tính có thể tắt chức năng truy cập mạng nội bộ, khiến
                không thể chạy test phiên bản hoặc ký số được vì call localhost
                báo lỗi.
              </Text>
              <Text size="sm" mb="md" c="gray.8" fw={500}>
                Để khắc phục, vui lòng làm theo các bước sau:
              </Text>

              <Box mb="md">
                <Text size="sm" fw={600} mb="xs" c="red.7">
                  Bước 1: Mở cài đặt trang web
                </Text>
                <Text size="sm" mb="xs" c="gray.7">
                  Nhấp vào biểu tượng khóa hoặc thông tin trang web ở thanh địa
                  chỉ trình duyệt (bên trái URL)
                </Text>
              </Box>

              <Box mb="md">
                <Text size="sm" fw={600} mb="xs" c="red.7">
                  Bước 2: Bật quyền truy cập mạng nội bộ
                </Text>
                <Text size="sm" mb="xs" c="gray.7">
                  Tìm mục <strong>"Quyền truy cập mạng cục bộ"</strong> hoặc{" "}
                  <strong>"Local network access"</strong> và bật chức năng này
                  (chuyển sang màu xanh/ON)
                </Text>
                <Flex
                  gap="md"
                  mt="md"
                  direction={{ base: "column", sm: "row" }}
                >
                  <Box
                    style={{
                      border: "1px solid #e9ecef",
                      borderRadius: "8px",
                      overflow: "hidden",
                      flex: 1,
                    }}
                  >
                    <img
                      src="/anhcapquyentruycapmangnoibotiengviet.png"
                      alt="Cấp quyền truy cập mạng nội bộ (Tiếng Việt)"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />
                  </Box>
                  <Box
                    style={{
                      border: "1px solid #e9ecef",
                      borderRadius: "8px",
                      overflow: "hidden",
                      flex: 1,
                    }}
                  >
                    <img
                      src="/anhcapquyentruycapmangnoibo.png"
                      alt="Cấp quyền truy cập mạng nội bộ (English)"
                      style={{
                        width: "100%",
                        height: "auto",
                        display: "block",
                      }}
                    />
                  </Box>
                </Flex>
              </Box>

              <Box
                style={{
                  padding: "10px",
                  backgroundColor: "#ffffff",
                  borderRadius: "6px",
                  border: "1px solid #dc3545",
                  marginTop: "12px",
                }}
              >
                <Text size="xs" c="red.8" fw={600}>
                  💡 Lưu ý: Sau khi bật quyền này, vui lòng tải lại trang để áp
                  dụng thay đổi. Nếu vẫn gặp lỗi, hãy kiểm tra lại cài đặt tường
                  lửa và phần mềm diệt virus.
                </Text>
              </Box>
            </Box>
          </Box>
        </ScrollArea.Autosize>
      ),
    });
  };
  const getMenu = async () => {
    const path = location.pathname;
    const isHomePage =
      path === "/" ||
      path === "/dashboard" ||
      path === "/method/folders-task-old";
    var resCheck =
      await repositorySign.get<MessageResponse<Array<string>>>(
        "/api/v1/home/check",
      );
    if (resCheck && resCheck?.data && resCheck.success) {
      if (resCheck.data && resCheck.data.length > 0) {
        const _checkRouter = _sideNavData
          .map((item) => {
            const filteredLinks = item?.links?.filter((linkObj) => {
              const condition1Index =
                resCheck?.data.findIndex((x) =>
                  linkObj.code.toLowerCase().includes(x.toLowerCase()),
                ) ?? -1;

              const condition2Index =
                resCheck?.data.findIndex((x) =>
                  item.code?.toLowerCase().includes(x.toLowerCase()),
                ) ?? -1;
              return condition1Index >= 0 || condition2Index >= 0;
            });
            return {
              ...item,
              links: filteredLinks,
            };
          })
          .filter(
            (item) => (item?.links?.length ?? item?.link?.length ?? 0) > 0,
          );
        // loc menu show ra
        setSideNavs(_checkRouter);
        const _reload = _sideNavData.find(
          (x) =>
            (x.link && path.startsWith(x.link)) ||
            (x.links && x.links?.find((xx) => path.startsWith(xx.link))),
        );
        const _checkNo =
          noCheckAuth.findIndex((x) => path.startsWith(x)) === -1;
        if (_checkNo && (!_reload || !resCheck.data.includes(_reload.code))) {
          if (!isHomePage) navigate(url403);
        }
      } else {
        if (!isHomePage) navigate(url403);
        setSideNavs([]);
      }
    }
  };

  return (
    <>
      <NewYearCelebration />
      <Modal
        opened={!!licenseError}
        onClose={() => setLicenseError(null)}
        withCloseButton
        closeOnClickOutside={false}
        closeOnEscape={false}
        yOffset="4vh"
        radius="md"
        size="lg"
        zIndex={1000000000}
        overlayProps={{ backgroundOpacity: 0.7, blur: 3 }}
        title={
          <Group gap="xs">
            <ThemeIcon color="red" variant="light" radius="xl" size="lg">
              <IconAlertTriangle size={20} />
            </ThemeIcon>
            <Text fw={700} c="red.7">
              {licenseError?.title}
            </Text>
          </Group>
        }
      >
        <Box>
          <Text size="sm" c="gray.8" mb="sm" style={{ lineHeight: 1.55 }}>
            An unhandled exception was thrown while initializing the Aspose
            licensing components. Document signing and generation are
            unavailable until the issue is resolved.
          </Text>
          <Box
            style={{
              fontFamily: "'Consolas', 'Courier New', monospace",
              fontSize: 12,
              lineHeight: 1.55,
              background: "#f8f9fa",
              border: "1px solid #e9ecef",
              borderRadius: 6,
              padding: "10px 12px",
              color: "#495057",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}
          >
            <span style={{ color: "#c92a2a" }}>{licenseError?.code}</span>:{" "}
            {licenseError?.message}
            {"\n   at Aspose.License.ValidateLicense(Stream stream)"}
            {"\n   at Aspose.License.SetLicense(String licenseName)"}
          </Box>
          <Text size="xs" c="gray.6" mt="sm">
            If the problem persists, please contact your system administrator.
          </Text>
        </Box>
      </Modal>
      <style>
        {`
          @keyframes blink {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.3; }
          }
        `}
      </style>
      <AppShell
        header={{ height: 60 }}
        navbar={{
          width: 260,
          breakpoint: "md",
          collapsed: {
            mobile: !desktopOpened,
            desktop: !desktopOpened,
          },
        }}
        padding="md"
      >
        <AppShell.Header
          h={60}
          style={{
            borderBottom: "1px solid #e9ecef",
            background: "linear-gradient(135deg, #ffffff 0%, #f1f3f4 100%)",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          <Flex justify={"space-between"} align={"center"} h="100%">
            <Group px="sm" w={130} flex={1} gap={2}>
              <Burger
                opened={desktopOpened}
                onClick={toggleDesktop}
                size="sm"
                color="#374151"
              />
              <Link to="/" style={{ textDecoration: "none" }}>
                <Group gap="sm">{renderLogo()}</Group>
              </Link>
            </Group>

            <Flex align="center" gap="sm" pr="sm">
              <NotificationBell />

              <Menu
                shadow="lg"
                width={window.innerWidth < 768 ? 180 : 220}
                radius="md"
                onOpen={() => setMenuOpened(true)}
                onClose={() => setMenuOpened(false)}
                position="bottom-end"
                offset={5}
              >
                <Menu.Target>
                  <UnstyledButton
                    style={{
                      padding: window.innerWidth < 768 ? "4px 8px" : "8px 16px",
                      borderRadius: "50px",
                      background: "rgba(59,130,246,0.1)",
                      border: "1px solid rgba(59,130,246,0.2)",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background =
                        "rgba(59,130,246,0.15)";
                      e.currentTarget.style.transform = "translateY(-1px)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 12px rgba(59,130,246,0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "rgba(59,130,246,0.1)";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <Flex
                      align={"center"}
                      gap={window.innerWidth < 768 ? "xs" : "sm"}
                    >
                      {userLogin?.avatar ? (
                        <Avatar
                          src={proxyAvatar(userLogin?.avatar, 32)}
                          size={window.innerWidth < 768 ? 24 : 32}
                          radius="xl"
                        />
                      ) : (
                        <Avatar
                          size={window.innerWidth < 768 ? 24 : 32}
                          radius="xl"
                          color="blue"
                          variant="light"
                        >
                          <IconUser size={window.innerWidth < 768 ? 14 : 18} />
                        </Avatar>
                      )}
                      {/* Luôn hiển thị tên trên mọi thiết bị */}
                      <div>
                        <Text
                          size={window.innerWidth < 768 ? "xs" : "sm"}
                          fw={500}
                          c="gray.8"
                          style={{ lineHeight: 1.2 }}
                        >
                          {userLogin?.name || userLogin?.userName || "User"}
                        </Text>
                        {/* Chỉ hiển thị userName phụ trên desktop */}
                        {window.innerWidth >= 768 && (
                          <Text
                            size="xs"
                            c="blue.6"
                            style={{ lineHeight: 1.2 }}
                          >
                            {userLogin?.userName}
                          </Text>
                        )}
                      </div>
                      {menuOpened ? (
                        <IconChevronUp
                          size={window.innerWidth < 768 ? 12 : 16}
                          color="#3b82f6"
                        />
                      ) : (
                        <IconChevronDown
                          size={window.innerWidth < 768 ? 12 : 16}
                          color="#3b82f6"
                        />
                      )}
                    </Flex>
                  </UnstyledButton>
                </Menu.Target>

                <Menu.Dropdown
                  p="sm"
                  style={{
                    border: "1px solid #e9ecef",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                  }}
                >
                  <Menu.Label
                    style={{
                      fontSize: "12px",
                      color: "#6c757d",
                      marginBottom: "8px",
                    }}
                  >
                    Tài khoản
                  </Menu.Label>

                  <Menu.Item
                    leftSection={<IconUser size={18} color="#495057" />}
                    onClick={handleNavigateToProfile}
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      borderRadius: "8px",
                      padding: "10px 12px",
                    }}
                  >
                    <Text size="sm" fw={500}>
                      Profile
                    </Text>
                  </Menu.Item>

                  <Menu.Item
                    leftSection={<IconSettings size={18} color="#495057" />}
                    onClick={() =>
                      modals.openConfirmModal({
                        title: "Đổi mật khẩu",
                        children: (
                          <>
                            <RecovyPassNodeCode />
                          </>
                        ),
                        labels: { confirm: "Đóng", cancel: "Cancel" },
                        onCancel: () => console.log("Cancel"),
                        onConfirm: () => console.log("Confirmed"),
                        cancelProps: { display: "none" },
                        confirmProps: { display: "none" },
                        size: "500px",
                        scrollAreaComponent: ScrollArea.Autosize,
                      })
                    }
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      borderRadius: "8px",
                      padding: "10px 12px",
                    }}
                  >
                    <Text size="sm" fw={500}>
                      Đổi mật khẩu
                    </Text>
                  </Menu.Item>

                  <Menu.Item
                    leftSection={<IconPencil size={18} color="#495057" />}
                    onClick={() =>
                      NotificationExtension.Success("Chức năng đang phát triển")
                    }
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      borderRadius: "8px",
                      padding: "10px 12px",
                    }}
                  >
                    <Text size="sm" fw={500}>
                      Công cụ ký số
                    </Text>
                  </Menu.Item>

                  <Menu.Divider style={{ margin: "8px 0" }} />

                  <Menu.Item
                    leftSection={<IconLogout size={18} color="#dc3545" />}
                    onClick={handleLogout}
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                      borderRadius: "8px",
                      padding: "10px 12px",
                      color: "#dc3545",
                    }}
                  >
                    <Text size="sm" fw={500} c="#dc3545">
                      Đăng xuất
                    </Text>
                  </Menu.Item>
                </Menu.Dropdown>
              </Menu>
            </Flex>
          </Flex>
        </AppShell.Header>
        <AppShell.Navbar p="md">
          <AppShell.Section>{searchModel}</AppShell.Section>
          <AppShell.Section grow component={ScrollArea}>
            <ScrollArea className={classes.links}>
              <div className={classes.linksInner}>{links}</div>
            </ScrollArea>
            <Box mt="md">
              <a
                style={{
                  listStyle: "none",
                  textDecoration: "none",
                  color: "ActiveBorder",
                  alignItems: "center",
                  display: "flex",
                  gap: "8px",
                  marginLeft: "20px",
                }}
                href="https://cdn-files.hacom.vn/hacom/extension/App-win/HacomSignSetup.exe"
              >
                <IconDownload color="#0065b3" size={16} />
                <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                  Tải bộ cài ký số
                </span>
                {isLatestVersion === false && (
                  <IconAlertCircle
                    color="#ff6b6b"
                    size={15}
                    style={{
                      animation: "blink 1.5s infinite",
                    }}
                  />
                )}
              </a>
              <Box
                mt="xs"
                style={{
                  marginLeft: "20px",
                  padding: "8px 12px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "6px",
                  border: "1px solid #e9ecef",
                }}
              >
                {isLoadingVersion ? (
                  <Text size="xs" c="gray.6">
                    Đang kiểm tra version...
                  </Text>
                ) : isLatestVersion === true ? (
                  <Text size="xs" c="green.6" fw={500}>
                    ✓ Bộ cài mới nhất
                  </Text>
                ) : (
                  <Text size="xs" c="orange.6" fw={500}>
                    {pluginStatus === "notRunning"
                      ? "⚠ Chưa kết nối HacomSign"
                      : "⚠ Cần cập nhật HacomSign"}
                  </Text>
                )}
                <Button
                  size="xs"
                  variant="light"
                  onClick={checkVersion}
                  loading={isLoadingVersion}
                  mt="xs"
                  fullWidth
                >
                  Kiểm tra
                </Button>
                <Button
                  size="xs"
                  variant="subtle"
                  onClick={openInstallGuideModal}
                  leftSection={<IconInfoCircle size={14} />}
                  mt="xs"
                  fullWidth
                  color="blue"
                >
                  Hướng dẫn cài đặt
                </Button>
              </Box>
            </Box>
          </AppShell.Section>
        </AppShell.Navbar>
        <AppShell.Main>
          {/* {isNavigating ? (
            <div>Loading skeleton...</div>
          ) : (
            <div>Your actual content</div>
          )} */}

          {loadingSkeleton ? (
            <SkeletonBase visible={true}></SkeletonBase>
          ) : (
            <>
              {/* <_breadcrumb></_breadcrumb> */}
              <Outlet />
            </>
          )}
        </AppShell.Main>
      </AppShell>
    </>
  );
};
